import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/partner/$organization/claims/$claimId')({
  component: () => <Navigate replace search from="/partner/$organization/claims/$claimId" to="/bo/claims/$claimId" />,
})
